let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("epSPI")).then(() => parcelRequire('81N3N'));